<template>
    <button v-if="cover" @click="openGallery">
        <img :src="cover" :alt="name" />
    </button>
    <div
        :id="id"
        class="grid gap-x-2 gap-y-4 xl:gap-x-4 max-lg:grid-cols-2"
        :class="[{hidden: cover}, `grid-cols-${cols}`]">
        <a
            v-for="(image, key) in imagesData"
            :key="key"
            :href="image.src"
            :data-pswp-width="image.w"
            :data-pswp-height="image.h"
            target="_blank"
            rel="noreferrer">
            <img
                :src="image.thumbnail"
                :alt="image.caption"
                class="m-auto w-auto max-h-36 max-xl:max-h-24 md:p-2 border border-gray-100" />
        </a>
    </div>
</template>

<script setup>
import {computed, onMounted, onUnmounted, ref, watch} from 'vue';
import {trans} from 'laravel-vue-i18n';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    cover: {
        type: String,
        default: null,
    },
    cols: {
        type: Number,
        default: 8,
    },
    images: {
        type: Array,
        required: true,
    },
});

const openGallery = () => {
    lightbox.value.loadAndOpen(0, {
        gallery: document.querySelector(`#${props.id}`),
    });
};

const imagesData = ref(props.images);

const options = computed(() => {
    return {
        gallery: '#' + props.id,
        children: 'a',
        closeTitle: trans('components.gallery.close'),
        zoomTitle: trans('components.gallery.zoom'),
        arrowPrevTitle: trans('components.gallery.previous'),
        arrowNextTitle: trans('components.gallery.next'),
        errorMsg: trans('components.gallery.image_error'),
        indexIndicatorSep: ' / ',
        pswpModule: () => import('photoswipe'),
    };
});

const lightbox = ref();

watch(options, () => {
    lightbox.value.options = options.value;
});

onMounted(() => {
    if (!lightbox.value) {
        lightbox.value = new PhotoSwipeLightbox(options.value);
        lightbox.value.init();
    }
});

onUnmounted(() => {
    if (lightbox.value) {
        lightbox.value.destroy();
        lightbox.value = null;
    }
});
</script>
